export default __webpack_public_path__ + "static/media/calculations.117ff763.png";